import React from 'react';
export function Footer() {
  return <footer className="bg-steel px-3 py-3 text-center sm:px-6" data-id="element-67" data-mp="32wd2qgad7ltj">
      <p className="text-[0.64rem] font-semibold text-white/80 sm:text-[0.74rem]" data-id="element-68" data-mp="3gfiu2hdxs9dl">
        © 2026 KITCHEN EQUIPMENT DIAGNOSTIC PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-white/65 sm:text-[0.72rem]" data-id="element-69" data-mp="36pfs3rou7l34">
        KITCHEN EQUIPMENT DIAGNOSTIC PRO™ is a diagnostic and professional reference resource. It
        does not replace manufacturer information, equipment-specific specifications, applicable
        regulations, safety procedures, professional technical training, required qualifications, or
        qualified professional judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-white/75 sm:text-[0.72rem]" data-id="element-70" data-mp="3qc3yp1m1nigw">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-71" data-mp="29yxdpewb9omv">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-72" data-mp="2ew734ujpa0ap">
          Privacy Policy
        </a>{' '}
        •{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-73" data-mp="3gb8xv7n4lmxp">
          Contact
        </a>
      </p>
      <p className="mt-0.5 text-[0.62rem] text-white/75 sm:text-[0.72rem]" data-id="element-74" data-mp="3v5dfkog732rd">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="3qazrl73v3xwq">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}